import { classNames } from "../../utils/styling-utils"
import { IEnkCalendarViewProps } from "./calendar-types"
import { DayInfo, getDayNames, getDayNumber } from "./utils"

export interface IEnkCalendarMonthProps extends IEnkCalendarViewProps {
  days: DayInfo[]
}

export function EnkCalendarMonth(props: IEnkCalendarMonthProps) {
  const { days, setSelectedDate, currentLocale } = props

  const handleDayClick = (day: Date) => {
    setSelectedDate(day)
  }

  const dayNames = getDayNames(currentLocale)

  return (
    <>
      <div className="mt-6 grid grid-cols-7 text-center text-xs leading-6 text-gray-500">
        {dayNames.map((day) => (
          <div>{day}</div>
        ))}
      </div>
      <div className="isolate mt-2 grid grid-cols-7 gap-px rounded-lg bg-gray-200 text-sm shadow ring-1 ring-gray-200">
        {days.map((day, dayIdx) => (
          <button
            key={day.date}
            type="button"
            className={classNames(
              day.isCurrentMonth ? "bg-white text-gray-900" : "bg-gray-50 text-gray-400",
              dayIdx === 0 ? "rounded-tl-lg" : "",
              dayIdx === 6 ? "rounded-tr-lg" : "",
              dayIdx === days.length - 7 ? "rounded-bl-lg" : "",
              dayIdx === days.length - 1 ? "rounded-br-lg" : "",
              "py-1.5 hover:bg-gray-100 focus:z-10"
            )}
            onClick={() => handleDayClick(new Date(day.date))}
          >
            <time
              dateTime={day.date}
              className={classNames(
                day.isToday && !day.isSelected ? "bg-gray-900 font-semibold text-white" : "",
                day.isSelected ? "bg-primary text-white" : "",
                "mx-auto flex h-7 w-7 items-center justify-center rounded-full"
              )}
            >
              {getDayNumber(day)}
            </time>
          </button>
        ))}
      </div>
    </>
  )
}
